import React from "react";
import { PageBuilderOpeningHeroSliderFragment } from "types/graphql-types";
import { graphql } from "gatsby";
import HeroBannerSlideshow from "components/HeroBannerSlideshow/HeroBannerSlideshow";
import { isPresent } from "src/utils/checks";

const PageBuilderOpeningHeroSlider: React.FC<
  React.PropsWithChildren<PageBuilderOpeningHeroSliderFragment>
> = ({ heroImages }) => {
  const filteredHeroImages = heroImages?.filter(isPresent) || [];
  return (
    <HeroBannerSlideshow
      slides={filteredHeroImages}
      newsMessage={undefined}
      enableAutoPlay
    />
  );
};

export default PageBuilderOpeningHeroSlider;

export const fragments = graphql`
  fragment PageBuilderOpeningHeroSlider on SanityOpeningHeroSlider {
    _key
    heroImages {
      ...HeroSlideContent
    }
  }
`;
